export const PRICING_TERMS =
  "Sprinters from $250/hour · Custom quotes given upon request · 50% deposit secures your date · Your final quote is always in writing before you book.";

export default function PricingTerms({ className = "" }: { className?: string }) {
  return (
    <p className={`text-sm font-medium tracking-wide leading-relaxed ${className}`}>
      {PRICING_TERMS}
    </p>
  );
}
